
import styled from 'styled-components'

export const Button = styled.button`
    border: none;
    border-radius: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    &:disabled {
        cursor: not-allowed
    }
`